import React, { useState, useEffect, useContext, useRef } from "react";
import { FaClipboardList } from "react-icons/fa";
import Offcanvas from "react-bootstrap/Offcanvas";
import AuditList from "../Audit/AuditObject.tsx";
import { AuditObjectTypes } from "../../_core/_model.ts";
import { getAuditObjectName } from "../../Utilities/Utilities.ts";
import TooltipButton from "../Tools/TooltipButton.tsx";
import { ThemeContext } from "../../context/ThemeContext.js";
import { joyrideAuditClass } from "../../UIComponents/JoyrideTour/JoyrideFunctions.tsx";

interface request {
    title: any,
    subHeader: any,
    cBody: any,
    bodyHeight: number,
    objectType: AuditObjectTypes | undefined,
    instanceId?: number,
    exButtons: any,
    fixedLayout?: boolean; // New prop
}

export function ComponentLayout({
    title,
    subHeader,
    cBody,
    bodyHeight,
    objectType,
    instanceId,
    exButtons,
    fixedLayout = true // default is true for backward compatibility
}: request) {
    const [showAudit, setShowAudit] = useState(false);
    const { themeConfig } = useContext(ThemeContext);
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const node = headerRef.current;
        if (!node) return;

        const updateHeight = () => {
            requestAnimationFrame(() => {
                const rect = node.getBoundingClientRect();
                setHeaderHeight(rect.height);
            });
        };

        const observer = new ResizeObserver(updateHeight);
        observer.observe(node);

        // ensure it updates when subHeader changes
        updateHeight();

        return () => observer.disconnect();
    }, [subHeader]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            const node = headerRef.current;
            if (node) {
                const rect = node.getBoundingClientRect();
                setHeaderHeight(rect.height);
            }
        }, 100); // small delay after render
        return () => clearTimeout(timeout);
    }, [subHeader]);

    return (
        <>
            {/* Header */}
            <div
                className={`container-fluid px-0 border-bottom border-top bg-theme-card ${fixedLayout ? 'bg-white' : ''}`}
                ref={headerRef}
            // style={{
            //     position: fixedLayout ? 'fixed' : 'relative',
            //     top: fixedLayout ? 56 : undefined,
            //     left: fixedLayout ? 260 : undefined,
            //     right: fixedLayout ? 0 : undefined,
            //     zIndex: fixedLayout ? 1040 : undefined,
            //     width: fixedLayout ? "calc(100% - 260px)" : "100%"
            // }}
            >
                <div className="d-flex flex-column gap-2 px-4">
                    <div className="d-flex justify-content-between align-items-center py-2">
                        <div className="fs-3 fw-semibold d-flex align-items-center">
                            {title}
                        </div>
                        <div className="d-flex align-items-center justify-content-end flex-fill">
                            <div className="d-flex align-items-center gap-2">
                                {exButtons}
                                {(typeof objectType != 'undefined') && (
                                    <TooltipButton title="View Audit Trail">
                                        <button
                    className={`btn btn-outline-primary ${joyrideAuditClass(title)}`}
                                            onClick={() => setShowAudit(true)}
                                            style={{ boxShadow: 'none' }}
                                        >
                                            <FaClipboardList size={16} />
                                        </button>
                                    </TooltipButton>
                                )}
                            </div>
                        </div>
                    </div>
                    {subHeader}
                </div>
            </div>

            {/* Body */}
            <div
                className="bg-theme-card w-100 d-flex flex-column"
                style={{
                    // marginTop: fixedLayout ? `${headerHeight}px` : 0,
                    background: themeConfig.colors.background,
                    fontFamily: 'Arial',
                    height: `calc(100% - ${headerHeight}px)`,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden"
                }}
            >
                {cBody}
            </div>

            {/* Audit panel */}
            {((typeof objectType != 'undefined') && instanceId !== undefined) && (
                <AuditList
                    instanceId={instanceId}
                    objectName={objectType}
                    auditObjectName={getAuditObjectName(objectType)}
                    setShowAudit={setShowAudit}
                    showAudit={showAudit}
                    asDrawer={true}
                />
            )}
        </>
    );
}

export default ComponentLayout;
